// Función para generar un stock ficticio y actualizar la barra de progreso
function updateRandomStock(productName) {
  let storedStock = localStorage.getItem(`randomStock_${productName}`);
  let storedTimestamp = localStorage.getItem(`randomStockTimestamp_${productName}`);
  const currentTimestamp = new Date().getTime();
  let randomStock;
  
  if (storedStock !== null && storedTimestamp !== null && (currentTimestamp - storedTimestamp < 43200000)) {
    randomStock = storedStock;
  } else {
    randomStock = Math.floor(Math.random() * (300 - 30 + 1)) + 30;
    localStorage.setItem(`randomStock_${productName}`, randomStock);
    localStorage.setItem(`randomStockTimestamp_${productName}`, currentTimestamp);
  }
  
  const barProgress = (randomStock / maxStock) * 100 + '%';
  
  document.getElementById('wbstockinfo-probar').style.width = barProgress;
  document.getElementById('wbstockinfo').innerHTML = `En stock (${randomStock} unidades), listas para enviar`;
}

// Actualizar al cargar la página
updateRandomStock(uniqueProductName);

// Actualizar cuando cambia la variante
document.addEventListener('variantChanged', function() {
  updateRandomStock(uniqueProductName);
});
